module.exports = __webpack_public_path__ + "static/media/img2.2620af5a.jpg";